import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import SuggestionCard from './SuggestionCard';
import { mockSuggestions as initialSuggestions } from '../../data/mockCommunity';
import { useAuth } from '../../context/AuthContext';
import { canManageRoadmap } from '../../constants/roles';

const columns = [
  { id: 'sugerida', title: 'Sugeridas', icon: 'Lightbulb', color: 'text-[var(--text-secondary)]' },
  { id: 'aceptada', title: 'Aceptadas', icon: 'ThumbsUp', color: 'text-brand-cyan' },
  { id: 'en_proceso', title: 'En Proceso', icon: 'Settings', color: 'text-brand-gold' },
  { id: 'completada', title: 'Completadas', icon: 'CheckCircle', color: 'text-brand-green' },
  { id: 'no_por_ahora', title: 'No por ahora', icon: 'Clock', color: 'text-rose-500' },
];

export default function RoadmapBoard() {
  const { role } = useAuth();
  const [suggestions, setSuggestions] = useState(initialSuggestions);
  const isLeaderView = canManageRoadmap(role);

  const handleUpdateStatus = (id, newStatus) => {
    setSuggestions(prev => prev.map(s => 
      s.id === id ? { ...s, status: newStatus } : s
    ));
  };

  return (
    <div className="w-full">
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl font-black text-[var(--text-main)] uppercase italic tracking-tight">
            Roadmap del Movimiento
          </h2>
          <p className="text-xs text-[var(--text-secondary)] font-medium mt-1">
            Propón, vota y decide el futuro de la plataforma.
          </p>
        </div>

        <div className="flex items-center gap-4 w-full md:w-auto">
          {isLeaderView && (
            <span className="text-[9px] font-bold text-brand-green uppercase tracking-widest whitespace-nowrap">
              Vista de líder activa
            </span>
          )}
          
          <button className="flex-1 md:flex-none gfi-gradient-bg text-brand-navy px-6 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all transform hover:scale-105 shadow-md flex items-center justify-center gap-2">
            <SafeIcon name="Plus" className="w-3.5 h-3.5" />
            Proponer Idea
          </button>
        </div>
      </div>

      <div className="w-full overflow-x-auto hide-scrollbar pb-12 px-6">
        <div className="flex gap-6 min-w-max">
          {columns.map(col => {
            const colSuggestions = suggestions.filter(s => s.status === col.id)
              .sort((a, b) => b.upvotes - a.upvotes);

            return (
              <div key={col.id} className="w-80 flex flex-col gap-4">
                <div className="flex items-center justify-between pb-3 border-b-2 border-[var(--border-subtle)]">
                  <div className="flex items-center gap-2">
                    <SafeIcon name={col.icon} className={`w-4 h-4 ${col.color}`} />
                    <h3 className="text-sm font-black text-[var(--text-main)] uppercase tracking-widest">
                      {col.title}
                    </h3>
                  </div>
                  <span className="bg-[var(--bg-surface)] text-[var(--text-secondary)] text-[10px] font-black px-2 py-0.5 rounded-md border border-[var(--border-subtle)]">
                    {colSuggestions.length}
                  </span>
                </div>

                <div className="flex flex-col gap-4">
                  {colSuggestions.length > 0 ? (
                    colSuggestions.map(s => (
                      <SuggestionCard 
                        key={s.id} 
                        suggestion={s} 
                        isLeader={isLeaderView} 
                        onUpdateStatus={handleUpdateStatus}
                      />
                    ))
                  ) : (
                    <div className="py-8 text-center border-2 border-dashed border-[var(--border-subtle)] rounded-2xl">
                      <p className="text-xs font-bold text-[var(--text-secondary)] uppercase tracking-widest opacity-50">
                        Vacio
                      </p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
